<div class="circle" [ngStyle]="{ 'width.px': diameter, 'height.px': diameter }" >
    <div class="rotation">{{ angle }}</div>
    <div class="circle-handle"
      circularSliderHandle
      [diameter]="diameter"
      [(angle)]="angle" >
    </div>
  </div>
  